import useSort from '@/composables/sort/sort';
import { goalActivity as goalActivityConfig } from 'shared/api/query/configs.json';
import { ref } from 'vue';

export default function useGoalActivitySorting(userSvc) {
  const attributeMap = { [goalActivityConfig.edges.customCreatedAt]: { type: 'date' } };
  const sortOptions = [
    { attr: goalActivityConfig.edges.customCreatedAt, desc: true },
  ];

  const properties = ref([]);

  const { sort } = useSort(attributeMap, properties, goalActivityConfig.edges.properties, userSvc);
  return {
    sort,
    sortOptions,
  };
}
